export const ActionTypes = {
  LOADING: "GENERATE_FACTS_LOADING",
  ERROR: "GENERATE_FACTS_ERROR",
  SUCCESS: "GENERATE_FACTS_SUCCESS",
};
